import styled from "styled-components";
import { getColor } from "utils";
import { ButtonProps } from "./interfaces";

const StyledButton = styled.button<ButtonProps>`
  background-color: ${({ color }) => getColor(color || 'brand')};
  padding: 15px;
  border-radius: 15px;
  transition: ease-in-out 0.3s all;
  border: none;
  width: 100%;
  display: flex;
  justify-content: center;
  cursor: pointer;
  position: relative;

  &.fetching {
    cursor: wait;
    opacity: 0.75;
  }

  &:disabled {
    opacity: 0.5;
  }

  &:hover {
    background-color: ${({ color }) => getColor(color || 'clearOverlay')};
  }

  ${({ variant }) => variant === "create" && `
    padding: 20px 40px;
    margin-top: 24px;
    max-width: 1100px;
    width: 100%;
    border-radius: 30px;
    background: ${getColor("brand")};
    border: 1px solid ${getColor("brand")};
    display: flex;
    justify-content: center;
    align-items: center;

    p {
      color: ${getColor("white")};
      font-weight: 600;
    }
  `}
`;

export default StyledButton;
